<template>
	<div>
		<v-dialog v-model="draftItemsDialog" no-click-animation persistent scrollable content-class="full-height select_field_dialog" lazy transition="dialog-bottom-transition">
	        <v-card>
	        	<v-card-title noshadow class="dialog_searchbox">
	        		<v-subheader full-width>Draft Items</v-subheader>

	        		<v-text-field  solo flat placeholder="Search" v-model="searchValue"></v-text-field>
	        	</v-card-title>
	        	
		        <v-card-text full-height nopadding :class="{'no-items-list-card': !filteredItems.length}">

			        <v-list two-line nopadding>
			        	<div v-for="(item, index) in filteredItems" :key="index">
			        		<v-list-tile>

					            <v-list-tile-content v-ripple @click="importDraft(item)">
					            	<v-list-tile-title>{{item.title ? item.title : '-'}}</v-list-tile-title>
					            	<v-list-tile-sub-title>{{item.modifiedDate | moment("DD-MMM-YYYY h:mm:ss a")}}</v-list-tile-sub-title>
					            </v-list-tile-content>

					            <v-list-tile-action v-ripple @click="removeDraftItem(item.draftId, index)">
							        <v-icon>delete</v-icon>
					            </v-list-tile-action>
				        	</v-list-tile>

				        	<v-divider v-if="filteredItems.length-1 != index"></v-divider>
			        	</div>
			        </v-list>

			        <div class="display_msg" v-if="!filteredItems.length">No Items</div>
		        </v-card-text>
		        <v-divider></v-divider>
		        <v-card-actions>
		        	<v-spacer></v-spacer>
          			<v-btn small color="blue darken-1" flat @click="$parent.fn_closeDialog">close</v-btn>
		        </v-card-actions>
		    </v-card>


	    </v-dialog>
	</div>
</template>

<script>
	export default{
		props:['draftItems', 'importDraft', 'removeDraftItem'],
		data(){
			return{
				draftItemsDialog:false,
				searchValue:''
			}
		},
		methods:{
			openDialogWeb: function () {
				this.searchValue = '';
				this.draftItemsDialog = true;
			},
			closeDialogWeb: function () {
				this.draftItemsDialog = false;
			}
			
		},
		computed:{
			filteredItems: function () {
		        let searchText = this.searchValue.toLowerCase();

		        return this.draftItems.filter(item => {
		          let draft = item.title ? item.title.toLowerCase() : '';
		          return draft.match(searchText);
		        })
		      }
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/dialogs/dialog_draft_items.vue